module.exports = "/assets/data/9f63bf8309e7ff5a1bfbcaf519661ec8-WN8.data.json";